import { useState } from 'react';
import { faqs } from '@/mocks/gossip';
import SectionHeading from './SectionHeading';

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="mx-auto w-full max-w-4xl scroll-mt-24 px-4 md:px-8 py-16 md:py-20">
      <SectionHeading
        eyebrow="玩法问答"
        title="吃瓜前先弄懂"
        accentWord="这些规则"
        desc="关于投票、投稿、私信与内容来源的常见疑问，一次讲明白。"
      />

      <div className="mt-8 flex flex-col gap-3">
        {faqs.map((f, i) => {
          const open = openIdx === i;
          return (
            <div
              key={f.q}
              className={`overflow-hidden rounded-2xl border bg-background-50 transition-colors ${
                open ? 'border-accent-300' : 'border-background-200'
              }`}
            >
              <button
                type="button"
                onClick={() => setOpenIdx(open ? -1 : i)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                aria-expanded={open}
              >
                <span className="flex items-center gap-3 text-base font-semibold text-foreground-950">
                  <span
                    className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                      open ? 'bg-accent-500 text-background-50' : 'bg-secondary-100 text-secondary-900'
                    }`}
                  >
                    Q
                  </span>
                  {f.q}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-xl text-foreground-700 transition-transform ${
                    open ? 'rotate-180 text-primary-500' : ''
                  }`}
                  aria-hidden="true"
                ></i>
              </button>
              <div
                className={`grid transition-all duration-300 ${open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}
              >
                <div className="overflow-hidden">
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-700 md:px-6">{f.a}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}